var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ns-loading",class:{ white: _vm.white },style:({
    width: _vm.width + 'px',
    height: _vm.width + 'px',
    'border-width': _vm.stroke + 'px',
  })})}
var staticRenderFns = []

export { render, staticRenderFns }